<template>
  <div class="form-group dateicker-wrapper">
    <label :for="id">{{ label }}</label>
    <div class="input-group mb-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
.dateicker-wrapper {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/DatepickerWrapper.vue